import styled, { css } from 'styled-components';
import media from 'styled-media-query';
import { Shimmer } from '~/styles/effects/shimmer';

type SkeletonProps = {
  loading: boolean;
};

export const Container = styled.div`
  width: 100%;
`;

export const LogoWrapper = styled.div``;

export const TitleRestaurant = styled.strong`
  font-size: 2.4rem;
`;

export const WrapperTableCount = styled.div`
  width: 100%;

  position: relative;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;

  border: 1px solid #e5e3dc;
  border-radius: 8px;

  padding: 0.5rem 1.5rem;
  margin-top: 1rem;
`;

export const TableCount = styled.span`
  font-size: 1.4rem;
  color: rgba(56, 97, 186, 1);
  font-weight: 700;
`;

export const Skeleton = styled.div<SkeletonProps>`
  ${({ loading }) => css`
    ${loading && css`
      width: 90%;
      height: 2rem;

      margin-bottom: 1rem;

      &:after {
        position: absolute;
        content: '';
        top: 50%;
        left: 5%;

        width: 90%;
        height: 2rem;

        background: #EAE7E3;
        -webkit-border-radius: 6px;
        -moz-border-radius: 6px;
        border-radius: 6px;

        background-image: linear-gradient(
          to right,
          #EAE7E3 0%,
          #DBD8D3 20%,
          #EAE7E3 40%,
          #EAE7E3 100%
        );
        background-repeat: no-repeat;
        -webkit-animation-duration: 1s;
        -webkit-animation-fill-mode: forwards;
        -webkit-animation-iteration-count: infinite;
        -webkit-animation-name: placeholderShimmer;
        -webkit-animation-timing-function: linear;
        animation: placeholderShimmer 1s linear infinite forwards;
        @keyframes placeholderShimmer {
          0% {
            background-position: -40rem 0;
          }
          100% {
            background-position: 40rem 0;
          }
        }
      }
    `};
  `}
`;

export const WaitTimeText = styled.p`
  font-size: 1.4rem;
  color: rgba(56, 97, 186, 1);
  font-weight: 700;

  margin-top: 1rem;
`;
